import { useDocumentMeta } from "../hooks/useDocumentMeta";
import { FinalCta } from "../components/FinalCta";
import { MethodSection, STEPS } from "../components/home/MethodAndCases";
import { Founders } from "../components/apropos/Founders";
import { BfmVideo } from "../components/apropos/BfmVideo";

const ABOUT_STEPS = [
    STEPS[0],
    STEPS[1],
    ["03", "Optimisation", "Vos banques sont-elles en adéquation avec votre stratégie financière et commerciale ? Si oui, nous négocions avec vos partenaires actuels. Si non, nous vous présentons de nouvelles banques adaptées à vos besoins."],
];

const Hero = () => (
    <section className="bg-navy text-cream">
        <div className="mx-auto max-w-[1180px] px-4 md:px-8 lg:px-12 py-12 md:py-[72px] lg:py-24 flex flex-col gap-[22px] animate-fade-up">
            <div className="text-[13px] font-semibold uppercase tracking-[0.16em] text-gold">À propos</div>
            <h1 className="m-0 font-bold text-[32px] md:text-5xl lg:text-[62px] leading-[1.15] tracking-[-0.02em] text-cream max-w-[920px]">
                Des anciens banquiers, une vision : <span className="text-gold">la juste répartition de la valeur.</span>
            </h1>
            <div className="w-40 h-1.5 bg-gold" />
        </div>
    </section>
);

const Intro = () => (
    <section className="mx-auto max-w-[1180px] px-4 md:px-8 lg:px-12 py-12 md:py-16 lg:py-[88px] flex flex-wrap gap-x-16 gap-y-10" data-testid="apropos-intro">
        <div className="flex-1 basis-[480px] min-w-0 flex flex-col gap-[18px] text-base leading-[1.75] text-grey-text">
            <p className="m-0">
                Votre entreprise est en croissance, vous gérez une PME ou une ETI et vous avez besoin pour votre développement d'une multitude de partenaires bancaires. Les frais s'accumulent, vous ne comprenez pas les factures, votre banquier vous explique que la tarification est normale et que c'est le prix à payer.
            </p>
            <p className="m-0 text-xl font-semibold text-navy leading-normal">Pourtant, non, ce n'est pas la réalité économique.</p>
            <p className="m-0">
                FOD est la marque de DMB Partners, spécialiste en optimisation des frais bancaires. Nous vous conseillons sur l'utilisation de vos comptes bancaires en fonction de votre business. Nous sommes les seuls en France et en Europe à être des pure players dans l'optimisation des frais bancaires.
            </p>
        </div>
        <div className="flex-1 basis-[320px] min-w-0 flex flex-col gap-4">
            {[
                ["20 000 €", "payés en moyenne chaque année par une PME française de 15 M€ de CA, pour la seule utilisation de ses comptes courants."],
                ["50 000 €", "c'est ce que ce montant peut atteindre avec une activité internationale."],
            ].map(([v, t]) => (
                <div key={v} className="bg-white border border-border-default rounded-[14px] p-6 flex flex-col gap-1.5">
                    <span className="font-bold text-[34px] lg:text-[44px] leading-none tracking-[-0.02em] text-navy tabular-nums">{v}</span>
                    <span className="text-sm leading-[1.55] text-grey-text-soft">{t}</span>
                </div>
            ))}
        </div>
    </section>
);

export default function APropos() {
    useDocumentMeta({
        title: "À propos — FOD by DMB Partners",
        description: "D'anciens banquiers au service des PME et ETI pour auditer et optimiser vos frais bancaires. Accords obtenus en trois semaines en moyenne.",
        canonical: "https://www.fodbydmb.com/a-propos",
    });
    return (
        <div data-testid="apropos-page">
            <Hero />
            <Intro />
            <Founders />
            <MethodSection steps={ABOUT_STEPS}>
                <p className="m-0 text-base leading-relaxed font-medium text-navy">
                    En moyenne, nous obtenons des accords et une mise en place des conditions en{" "}
                    <span className="text-gold-text font-bold">trois semaines</span> après l'analyse de l'ensemble de vos frais bancaires.
                </p>
            </MethodSection>
            <BfmVideo />
            <FinalCta band title="Prêt à reprendre la main sur vos frais ?" text="En 30 secondes, estimez combien votre entreprise pourrait économiser." />
        </div>
    );
}
